module.exports = __webpack_public_path__ + "img/38738-022.787005e0.jpg";